import { LINK_ITEMS } from './links';

export const REVEAL = {
  name: 'ADARSH DHAWALE',
  title: 'Full-Stack Software Engineer | AI/ML & Automation',
  education: 'B.E. Artificial Intelligence & Machine Learning, expected 2027',
  tagline:
    "You didn't just visit my portfolio.\nYou experienced my journey.",
  skills: [
    'Python',
    'JavaScript',
    'TypeScript',
    'React',
    'Next.js',
    'Node.js',
    'MongoDB',
    'Docker',
    'Azure',
    'AWS',
    'LLMs',
    'Machine Learning',
    'RAG',
    'LangChain',
  ],
  achievements: [
    'MindSpark BrainStorm AI & ML Hackathon — 2nd Runner-Up',
    'PEAGYANTRA — 1st Runner-Up',
    'Smart India Hackathon — Top 5',
  ],
  certifications: [
    'Oracle Agentic AI Professional Certification',
    'Google Developer Bootcamp',
    'Coursera Machine Learning Certifications',
  ],
  /** @deprecated prefer achievements + certifications */
  trophies: [] as string[],
  projects: [
    {
      season: 'Projects',
      name: 'CredNova',
      summary:
        'Machine-learning credit scoring with SHAP explainability — Django, React, Azure, XGBoost.',
      tags: ['SHAP', 'Django', 'React', 'Azure', 'XGBoost'],
    },
    {
      season: 'Projects',
      name: 'LearnForge',
      summary:
        'Adaptive AI Tutor with LangChain RAG, Bayesian Knowledge Tracing, Vectorless RAG, and MCP automation.',
      tags: ['RAG', 'LangChain', 'Qdrant', 'Bayesian KT', 'MCP', 'LLMs'],
    },
    {
      season: 'Projects',
      name: 'MADAlgos',
      summary:
        'Cloud deployment on Azure with Next.js, Judge0, and microservices — supporting concurrent learners at scale.',
      tags: ['Next.js', 'Judge0', 'Azure', 'Microservices'],
    },
    {
      season: 'Projects',
      name: 'Leadgate',
      summary:
        'MERN stack, AI chatbot, admin dashboard, and REST APIs that powered day-to-day operations.',
      tags: ['MERN', 'AI Chatbot', 'Admin Dashboard', 'REST APIs'],
    },
  ],
  experience: [
    {
      title: 'Full-Stack & AI/ML Engineering',
      detail:
        'Shipping intelligent systems — from credit scoring to educational AI — with production cloud deployments.',
    },
    {
      title: 'Builder of Intelligent Systems',
      detail:
        'Every sprint in The Final maps to real learning: APIs, agents, models, and the ops that keep them alive.',
    },
  ],
  links: LINK_ITEMS,
  closing:
    "You didn't just visit my portfolio.\nYou experienced my journey.",
};

// Keep trophies array populated for any legacy UI
REVEAL.trophies = [...REVEAL.achievements, ...REVEAL.certifications];
